import { nextLine, bold, subscript } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  certificateUploadProcess: {
    createNew: {
      description: `Upload a new certificate here.<br>You can enter the data manually or upload a file with the grid connection values.`,
      title: "New Certificate",
    },
    replaceExisting: {
      description: `Replace a certificate here.<br>Only applies to standards VDE-AR-N 4110, VDE-AR-N 4120 and VDE-AR-N 4130.`,
      title: "Replace Existing Certificate",
      extendTitle: "Extend Existing Certificate",
    },
    gridFormingCertificate: {
      description: `Upload a certificate here that meets the requirements of the VDE FNN guideline Version 2.1 <b>"Technical requirements for grid-forming capabilities including provision of inertia"</b>.<br />Inertia parameters can also be conveniently imported via an extended list of grid connection values, which you can download directly on the corresponding forms.`,
      uploadFormDescription: `You can download an extended list of grid connection values here, which allows you to also import data regarding parameters of inertia.`,
      downloadLinkDE: "German version",
      downloadLinkEN: "English version",
      title: "New certificate for grid-forming units",
      replaceTitle: "Replace existing certificate for grid-forming units",
      extendTitle: "Extend existing certificate for grid-forming units",
    },
    gridFormingCertificateEdit: {
      description: `You can edit the matrix parameters and grid connection values manually or update them using a VDE list.<br />Then check the correctness of the data and click submit.`,
      title: "Edit certificate for grid-forming units",
    },
    edit: {
      description: "Edit an existing certificate.",
      title: "Edit existing certificate",
    },
    import: {
      description: "Bearbeiten Sie ein migriertes Zertifikat.",
      title: "Edit migrated certificate",
    },
    replaceCertificatePropmt: "Enter the certificate number of the certificate that you want to replace",
    withdrawCertificateOption: "Withdrawn (replaced by)",
    extendValidityOption: "Valid (extended by)",
  },
  noOptionsText: "No certificates found to replace",
  addUnit: "Add Unit",
  createUnit: "Create Unit",
  linkexistingUnit: "Link existing Unit",
  linkexistingUnitDescription: "Enter model name or unit number",
  animationTitle: "...loading",
  noCertificateTypeSelected:
    "Please first select the type of verification document (1.12) in order to be able to specify unit parameters!",
  category: "Certificate Category",
  certificationAuthority: "Certification Body",
  certificateFileTooLarge: "The file is too large. Please use a file with a maximum size of 20 MB.",
  certificateIssueDate: "Certificate valid from",
  comment:
    "Please review the scanned data from the uploaded data sheet and make any necessary adjustments in unit parameters. Press the 'Submit' button for confirmation.",
  dataSheet: "Data Sheet",
  discardChanges: "Discard changes?",
  docs: "Uploaded Documents",
  errorMessages: {
    nonLatinCharacters: "Please use Latin Letters only (A-Z)",
    categoryInvalidForNorm: "This category is not valid for this Norm!",
    categoryRequired: "The Category is required!",
    norm4105NotSupportedForGridForming: "Norm VDE-AR-N 4105 is not supported for grid forming certificates.",
    norm4105NotSupportedForGridFormingTitle: "Norm VDE-AR-N 4105 not supported",
    categoryNotSupportedForGridForming:
      "The following categories are not supported for grid forming certificates: NS protection, PAV,E-monitoring, Voltage regulator (interposed), Protection device, PGS controller, Other.",
    categoryNotSupportedForGridFormingTitle: "Category not supported",
    certificateTypeNotSupportedForGridForming:
      "Manufacturer declaration is not supported for grid forming certificates.",
    certificateTypeNotSupportedForGridFormingTitle: "Verification document not supported",
    someUnitsHaveErrors: "Some units have errors",
    certificateAlreadyExists: "This Certificate already exists",
    certificateCoverSheetRequired: "The Certificate cover sheet is required",
    perturbationsTestReportRequired: "The Certificate/Perturbations Test Report is required",
    softwareVersionRequired: "The Software Version is required",
    manufacturerUnitAlreadyExists: "This Manufacturer already has a unit with this name",
    manufacturerIsRequired: "The Manufacturer is required",
    manufactucturerIdDifferentToUnitManufacturer: "The Manufacturer does not match the linked unit(s) manufacturer",
    modelAlreadyExists: "This Model already exists",
    normRequired: "The Norm is required",
    requieredIfGreater10: "This field is required if Norm is greate or equal to 10",
    unitHasCountErrors: "The unit {unitName} has {errorCount} errors",
    duplicateUnitNames: "A certificate cannot have multiple units with the same name",
    requieredIfCategory: "This field is required for the combination of Norm & Category",
    requieredIfCategoryAndMaxRated: "This field is required for the combination of Norm, Category & Max Rated Power",
    tooManyFractionalDigits:
      "Input does not meet the format requirements, maximum {maxDecPlaces} decimal places allowed.",
    withTG8Rev25ConformityOnNorm5: "This field is only valid for Norms greater or equal to 10",
    withTG8Rev25ConformityRequired: "This field is required if TG8 Rev. 9 Conformity is active",
    fileReadErrorTitle: "File could not be read",
    fileReadError: "The selected file could not be read. Please check the file and try again.",
    required: "This field is required",
    aggregatedFileSize:
      "The files selected for upload are too large. Please upload files with a total size of max 30 MB.",
    newUnitRequiredInExtendedValidityFlow:
      "To extend certificate validity, please add a new unit or modify at least one of: issue date, norm, restrictions, or software version.",
    matrixParametersRequired: "All fields for inertia parameters are required",
    matrixParameterRangeRequired: "All values in a configurable range must be filled out",
    matrixParametersInvalidFormat: "Inertia parameters have an invalid format",
    matrixParametersTaMinRequired: "taMin fields must be filled out",
    matrixParametersTaMaxRequired: "taMax fields must be filled out",
    matrixParametersAllFieldsRequired: `All fields in {section} must be filled in`,
    matrixParametersZeroNotAllowed: "All fields in {section} must be filled in with non-zero values",
    matrixParametersZwMustBeGreaterThanZero: `The effective impedance value must be greater than 0.`,
    matrixParametersOrderingViolation:
      "Values for {field} must be in ascending order: 0 < T_A,min <= T_A,1 < ... < T_A,n <= T_A,max",
    matrixParametersDuplicateTaValue: `No duplicate values allowed for start-up time constants.`,
    matrixParametersError: "Error in inertia parameters",
  },
  field: {
    category: "Certificate Category",
    certificationAuthority: "Certification Body",
    certificateIssueDate: "Certificate valid from",
    manufacturer: "Manufacturer",
    validityStatus: "Status",
  },
  feedBack: {
    error: {
      title: "Certificate Creation Error",
      body: "There was a problem creating the certificate. Please try again.",
    },
    success: {
      title: "Certificate Created",
      body: "The certificate and associated units were successfully uploaded.",
    },
    successReplace: {
      title: "Certificate Replaced",
      body: "The new certificate and associated units were successfully uploaded. The previous certificate was successfully replaced.",
    },
    successExtend: {
      title: "Certificate Extended",
      body: "The new certificate was successfully created as an extension. All units from the certificate chain have been automatically linked to the new certificate.",
    },
    successEdit: {
      title: "Certificate Edited",
      body: "The certificate was successfully edited.",
    },
    successEditChained: {
      title: "Certificate Edited",
      body: "The certificate was successfully edited. Changes to the status are automatically applied to ALL certificates in this certificate chain!",
    },
  },
  info: "Certificate Info",
  label: "Upload Certificate",
  pdfCertificate: "PDF Certificate",
  placeHolderCertificationBodyForManufacturersDeclaration: "Manufacturer's declaration without certification body",
  renameFile: "Rename File",
  resetButtonLabel: "Reset Changes",
  title: "Units & Parameters",
  unsavedChanges:
    "You have commited unsaved changes. If you leave the upload process all changes will be lost. Do you want to leave and discard all changes?",
  uploadFormDescription:
    "You can either upload an Excel file for automatic data scanning. Then check the correctness of the data and click submit. Alternatively, manually input the required data, double-check, and submit the form.",
  updateFormDescription: {
    import: `You can either copy the parameters using an Excel template or enter them manually. Then check that the data is correct and submit the form.
        ${nextLine()}${bold("Please note:")}${nextLine()}
        When uploading an Excel template, only the performance parameters (1.20 - 1.68) are transferred for migrated certificates. All values relating to the certificate (1.01 - 1.19) are ignored.
        ${nextLine()}These may have to be adjusted manually.
        ${nextLine()}The certificate loses the attribute “migrated” when it is edited for the first time.
      `,
  },
  uploadFormTitle: "Upload Certificate",
  noUnitsFound: "No matching units found",
  fileVisibility: {
    modalTitle: "Configure File Visibility",
    description: "Control which roles and organizations can access this file. Leave empty for default visibility.",
    grantAccessToRoles: "Grant access to roles",
    grantAccessToTenants: "Grant access to organizations",
    searchTenants: "Search for organizations...",
    summary: "Access granted to:",
    configureAccess: "Configure file visibility",
    accessGrantedTo: "Access granted to",
  },
  unitVisibility: {
    modalTitle: "Configure Unit Parameter Visibility",
    description:
      "Control which roles and organizations can access unit parameters for this unit. Leave empty for default visibility.",
    grantAccessToRoles: "Grant access to roles",
    grantAccessToTenants: "Grant access to organizations",
    searchTenants: "Search for organizations...",
    summary: "Access granted to:",
    configureAccess: "Configure unit parameter visibility",
    accessGrantedTo: "Access granted to",
  },
  matrixVisibility: {
    modalTitle: "Configure Matrix Parameter Visibility",
    description:
      "Control which roles and organizations can access matrix parameters for this unit. Leave empty for default visibility.",
    grantAccessToRoles: "Grant access to roles",
    grantAccessToTenants: "Grant access to organizations",
    searchTenants: "Search for organizations...",
    summary: "Access granted to:",
    configureAccess: "Configure matrix parameter visibility",
    accessGrantedTo: "Access granted to",
  },
  gridFormingTypeSelection: {
    title: "Select Generation Unit",
    type1: {
      title: "Type 1",
      description: "Generation units with synchronous generator",
    },
    type2: {
      title: "Type 2",
      description: "Generation units with inverter or asynchronous generator",
    },
  },
  matrixParametersType1: {
    title: "Inertia Parameters",
    taGenLabel: "Generator start-up time constant",
    taZusLabel: "Start-up time constant of the additional flywheel with coupled generator",
    taGesLabel: "Inertia of the entire wave train (total system)",
    labelColumnHeader: "Label",
    unitColumnHeader: "Unit",
    valueColumnHeader: "Value",
    sumValidationError: `T${subscript("A,gen")} + T${subscript("A,zus")} must equal T${subscript("A,ges")}`,
    allFieldsRequired: "All fields for inertia parameters must be filled in.",
  },
  enterValue: "Enter value",
  addStartUpTimeConstant: "Add parameterizable sector",
  addEffectiveImpedance: "Add effective impedance",
};
